import http from '../../http-common';
import store from '@/store';

class GetInitData {
  static baseUrl = process.env.VUE_APP_HISTORY_MODULE_BASE_URL;

  static getInitData(payload) {
    let clientId = '';
    let sessionId = '';
    if(store.state.smaDetails && store.state.smaDetails.agentID){
      clientId = store.state.smaDetails.agentID;
      sessionId = store.state.smaDetails.sessionID;
    } else {
      clientId = store.state.sessionPayload.agentId;
      sessionId= store.state.historyModuleSession;
    }
   return http.post(GetInitData.baseUrl + '/web/history/init', {
   
      clientId: clientId,
      sessionId: sessionId,
      aggId: '8321',
      mode: 'WEB',
      udf1: 'HISTORY_SELFCARE',
      udf2: '',
      payload: payload,
    });
  }
}

export default GetInitData;
